import React from 'react';
import { Layout } from '../components/Layout';

const CalendarPage: React.FC = () => {
  return (
    <Layout>
      <div className="p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Calendario</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">Página de calendario en desarrollo...</p>
        </div>
      </div>
    </Layout>
  );
};

export default CalendarPage;